<script lang="ts">
    import { twMerge } from "tailwind-merge"

    export let darkColor: string
    export let lightColor: string

    let className = ""
    export { className as class }

    export let bubbleClass = ""
</script>

<div class={twMerge("relative h-9 w-9 flex-shrink-0", className)} {...$$restProps}>
    <div
        class={twMerge(
            "absolute w-8 h-8 rounded-full overflow-hidden bg-black left-0 top-0 translate-x-1 translate-y-1",
            bubbleClass
        )}
        
    >
        <div class=" absolute w-full h-full" style:background={darkColor} />
    </div>
    <div
        class={twMerge("absolute w-8 h-8 overflow-hidden bg-white rounded-full left-0 top-0", bubbleClass)}
        
    >
        <div class=" absolute w-full h-full" style:background={lightColor} />
    </div>
    <slot name="icon" />
</div>
